import { useSearchParam } from './useSearchParam';

export const SSR_QUERY_PARAM_NAME = '_isSSR';
export const SSR_POSITIVE_QUERY_VALUE = '1';

export function useIsSSRMode() {
  return useSearchParam(SSR_QUERY_PARAM_NAME) === SSR_POSITIVE_QUERY_VALUE;
}
